module.exports = __webpack_public_path__ + "static/media/reminder-bell.cfc728e2.svg";